function header_sticky () {
    const $header = document.querySelector('.l-header');
    if ($header) {
        const scrollLoc = $header.dataset.previousScrollLocation ? parseInt($header.dataset.previousScrollLocation) : actGetScroll();
        const headerLoc = $header.dataset.previousHeaderLocation ? parseInt($header.dataset.previousHeaderLocation) : 0;
        let curLoc = parseInt(actGetScroll());
        let newHeadLoc = scrollLoc - curLoc + headerLoc;
        // Le multiplicateur est la pour que le principe qui cache
        // le header arrête pas exactement au moment ou il est hors de la page.
        let headSize = $header.offsetHeight * 1.1;
        if (newHeadLoc < -headSize) {
            newHeadLoc = -headSize;
        }
        else if (newHeadLoc > 0) {
            newHeadLoc = 0;
        }
        $header.dataset.previousScrollLocation = actGetScroll();
        $header.dataset.previousHeaderLocation = newHeadLoc;
        $header.setAttribute('style', 'top:calc(' + newHeadLoc + 'px )');

            // transparency_header();

    }
}

window.addEventListener('scroll', header_sticky);

header_sticky();

function actGetScroll () {
    if (window.pageYOffset != undefined) {
        //return [pageXOffset, pageYOffset];
        return pageYOffset;
    }
    else {
        var sx, sy, d = document,
            r = d.documentElement,
            b = d.body;
        sx = r.scrollLeft || b.scrollLeft || 0;
        sy = r.scrollTop || b.scrollTop || 0;
        //return [sx, sy];
        return sy;
    }
}

function transparency_header () {
    var first_block = document.querySelector('main > div.entry-content > div');
    var first_block_cover_condition = first_block.classList.contains('wp-block-cover');
    if(first_block_cover_condition && first_block.classList.contains('is-style-hero-home-subsite')){
        first_block_cover_condition = false;
    }
    if (first_block_cover_condition ||  first_block.classList.contains('act-gallery-cover')) {
        let header = document.querySelector('header');
        let header_height = header.clientHeight;
        let position = header.getAttribute('data-previous-scroll-location');
        if (position==0 || !header.hasAttribute('data-previous-scroll-location')) {
            header.classList.add('l-header--header_cover');
            header.onmouseover = function () {
                header.classList.remove('l-header--header_cover')
            }
            header.onmouseout = function () {
                header.classList.add('l-header--header_cover')
            }
        }
        else if(document.documentElement.scrollTop > (header_height + 20)){
            header.classList.remove('l-header--header_cover')
            header.onmouseover = function () {
                header.classList.remove('l-header--header_cover')
            }
            header.onmouseout = function () {
                header.classList.remove('l-header--header_cover')
            }
        }
        header.style.position = 'fixed';
        let main = document.querySelector('main');
        const paddingTop = window.getComputedStyle(first_block, null).getPropertyValue('padding-top').match(/\d+/)[0];
        first_block.style.paddingTop = parseInt(header_height) + 'px';
        if(first_block.classList.contains('act-gallery-cover')){
            first_block.style.setProperty("--data-padding-top", parseInt(header_height) + 'px');
        }
        main.classList.add('l-header--header_cover');
    }

}

/*
if (document.readyState === 'complete' || (document.readyState !== 'loading')) {
    transparency_header();
}
else {
    document.addEventListener('DOMContentLoaded', transparency_header);
}
*/
